import SEO from '@/components/SEO';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import { useLanguage } from '@/contexts/LanguageContext';

const Privacy = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title={t('Πολιτική Απορρήτου', 'Privacy Policy')}
        description={t('Πολιτική απορρήτου της TFT - Tesco Food Technology.', 'Privacy policy of TFT - Tesco Food Technology.')}
      />
      <Navigation />
      
      <main className="flex-1 py-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl font-bold mb-8">
            {t('Πολιτική Απορρήτου', 'Privacy Policy')}
          </h1>
          
          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">
                {t('Εισαγωγή', 'Introduction')}
              </h2>
              <p className="text-muted-foreground">
                {t(
                  'Η TFT - Tesco Food Technology S.A. δεσμεύεται για την προστασία των προσωπικών δεδομένων σας. Αυτή η πολιτική απορρήτου εξηγεί πώς συλλέγουμε, χρησιμοποιούμε και προστατεύουμε τα προσωπικά σας δεδομένα.',
                  'TFT - Tesco Food Technology S.A. is committed to protecting your personal data. This privacy policy explains how we collect, use and protect your personal data.'
                )}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">
                {t('Συλλογή Δεδομένων', 'Data Collection')}
              </h2>
              <p className="text-muted-foreground">
                {t(
                  'Συλλέγουμε πληροφορίες που μας παρέχετε απευθείας, όπως όταν επικοινωνείτε μαζί μας ή συμπληρώνετε φόρμες στον ιστότοπό μας.',
                  'We collect information that you provide directly to us, such as when you contact us or fill out forms on our website.'
                )}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">
                {t('Χρήση Δεδομένων', 'Data Usage')}
              </h2>
              <p className="text-muted-foreground">
                {t(
                  'Χρησιμοποιούμε τα δεδομένα σας για να παρέχουμε και να βελτιώσουμε τις υπηρεσίες μας, να επικοινωνήσουμε μαζί σας και να συμμορφωθούμε με τις νομικές μας υποχρεώσεις.',
                  'We use your data to provide and improve our services, communicate with you and comply with our legal obligations.'
                )}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold mb-4">
                {t('Τα Δικαιώματά Σας', 'Your Rights')}
              </h2>
              <p className="text-muted-foreground">
                {t(
                  'Έχετε το δικαίωμα πρόσβασης, διόρθωσης ή διαγραφής των προσωπικών σας δεδομένων. Επικοινωνήστε μαζί μας για να ασκήσετε αυτά τα δικαιώματα.',
                  'You have the right to access, correct or delete your personal data. Contact us to exercise these rights.'
                )}
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Privacy;
